module.exports = __webpack_public_path__ + "static/media/eye-dropper.15690467.svg";